(() => {
  const textReplacements = new Map([
    ['coming soon', 'Notify me'],
    ['notify me when available', 'Notify me'],
    ['notify me when this is back in stock', 'Notify me'],
  ]);

  const skipTags = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT']);

  function normalize(text) {
    return text.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function closestLabelElement(node) {
    return node.parentElement?.closest('button, a, span, p, div, label, li');
  }

  function polishTextNode(node) {
    const current = normalize(node.textContent || '');
    if (!textReplacements.has(current)) return;

    const replacement = textReplacements.get(current);
    const wasComingSoon = current === 'coming soon';
    node.textContent = node.textContent.replace(node.textContent.trim(), replacement);

    const label = closestLabelElement(node);
    if (!label) return;

    label.classList.add('dj-notify-polished');
    if (wasComingSoon) {
      label.classList.add('dj-notify-envelope');
    }
  }

  function polish(root = document.body) {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.textContent || !normalize(node.textContent)) return NodeFilter.FILTER_REJECT;
        if (skipTags.has(node.parentElement?.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(polishTextNode);
  }

  polish();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          polishTextNode(node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          polish(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
